var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUrl = function SvgIconUrl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.264.93v4.56c0 .957-.66 1.646-1.729 1.65-1.074-.004-1.743-.693-1.738-1.65V.93H.723v4.648c-.005 1.484 1.108 2.54 2.812 2.54 1.69 0 2.808-1.056 2.803-2.54V.93H5.264ZM7.784 8h1.073V5.334h1.514L11.807 8h1.22l-1.562-2.856c.86-.328 1.289-1.045 1.289-1.998 0-1.303-.806-2.216-2.451-2.216h-2.52V8Zm1.073-3.594V1.848h1.338c1.04.005 1.475.503 1.475 1.298 0 .796-.435 1.255-1.475 1.26H8.857ZM13.945 8h4.268v-.928h-3.194V.93h-1.074V8Z",
    fill: "#000"
  })));
};
export default SvgIconUrl;